<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      
                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12">
                                                <div class="row">

                                                    <div class="col-xl-5 col-lg-5 col-md-7">
                                                        <div class="submit-field">
                                                            <h5>Nome</h5>
                                                            <input type="text" class="with-border" placeholder="Informe o nome aqui.." v-model="form.nome">
                                                        </div>
                                                    </div>


                                                    <div class="col-xl-4 col-xs-12 col-md-5 col-lg-5" v-show="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                                        <div class="submit-field">
                                                            <h5>Filial</h5>
                                                            <select class="with-border" v-model="form.empresaCod">
                                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                            </select> 
                                                        </div>
                                                    </div>                                                                                           
                                                    
                                                    <div class="col-xl-3 col-xs-6 col-md-5 col-lg-5">
                                                        <div class="submit-field">
                                                            <h5>Tipo</h5>
                                                            <select class="with-border" v-model="form.tipo">
                                                                <option value="" disabled selected hidden>Selecione..</option>
                                                                <option value="tanque">Tanque fixo</option>
                                                                <option value="cta">CTA (caminhão)</option>
                                                            </select>
                                                        </div>
                                                    </div>               

                                                    <!-- <div class="col-lg-12 hidden-lg hidden-md clearfix"></div> -->

                                                    <div class="col-xl-3 col-xs-6 col-md-5 col-lg-5">
                                                        <div class="submit-field">
                                                            <h5>Produto</h5>
                                                            <select class="with-border" v-model="form.catalogoCod">
                                                                <option value="" disabled selected hidden>Selecione..</option>
                                                                <option v-for="item in catalogo.itens" :value="item.cod">{{item.nome}}</option>
                                                            </select> 
                                                        </div>
                                                    </div>   

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6">
                                                        <div class="submit-field">
                                                            <h5>Quantidade atual <br class="hidden-lg hidden-md hidden-xl">(litros)</h5>
                                                            <input type="number" class="with-border" placeholder="" v-model="form.quantidade">
                                                            <!-- <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######']"  type="tel" class="with-border" placeholder="" v-model="form.quantidade" /> -->
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6">
                                                        <div class="submit-field">
                                                            <h5>Capacidade total <br class="hidden-lg hidden-md hidden-xl">(litros)</h5>
                                                            <!-- <input type="tel" class="with-border" placeholder="" v-model="form.capacidade"> -->
                                                            <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######']"  type="tel" class="with-border" placeholder="" v-model="form.capacidade" />
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6">
                                                        <div class="submit-field">
                                                            <h5>Numeração</h5>
                                                            <input type="number" class="with-border" placeholder="" v-model="form.numero" />
                                                            <!-- <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######', '########', '#########', '##########']"  type="tel" class="with-border" placeholder="" v-model="form.numero" /> -->
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6">
                                                        <div class="submit-field">
                                                            <h5>Medição do <br class="hidden-lg hidden-md hidden-xl">tanque (cm)</h5>
                                                            <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######', '########', '#########', '##########']"  type="tel" class="with-border margin-bottom-5" placeholder="_____" v-model="form.medicao" />
                                                            <!-- <small class="margin-bottom-0">Opcional</small> -->
                                                        </div>
                                                    </div>                                                      

                                                    <div class="col-xl-12 margin-bottom-20">
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            {{ form.cod ? 'Salvar estoque' : 'Cadastrar estoque' }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarEstoque',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {             
            "loading": {
                "submit":           false
            },
            "catalogo": {
                "itens":            []
            },
            "empresas": {
                "itens":            []
            },            
            "form": {
                "cod":              "",
                "tipo":             "",
                "nome":             "",
                "catalogoCod":      "",
                "empresaCod":       "",
                "quantidade":       "",
                "capacidade":       "",
                "medicao":          "",
                "numero":           "2"
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            axios[a]("api/estoque.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },         
        getCatalogo: function() {
            var self        = this;
            console.log("getCatalogo()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "catalogo",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "catalogo"
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("getCatalogo() response", response);
                    self.catalogo       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCatalogo() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },          
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/estoque.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {
            console.log("init()");
            var self = this;
            if (self.$root.user.tipo == "prestador") {
                self.form.empresaCod = self.$root.user.empresaCod;
            }

            self.$root.tmp.estoque.tab = "editar";

            if (self.$route.name == "EditarEstoque") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod = self.$route.query.c;
                Promise.all([
                    self.get(),
                    self.getEmpresas(),
                    self.getCatalogo()
                ]).then(function() {
                
                    loading.hide();
                    
                }).catch(function(error) {
                    loading.hide();
                });  

            } else {                
                Promise.all([
                    self.getEmpresas(),
                    self.getCatalogo()
                ]).then(function() {
                
                    loading.hide();
                    
                }).catch(function(error) {
                    loading.hide();
                });             
            }
        }     
    },    
    created: function() {
        var self = this;
        console.log("created", self);
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }       

    },
    mounted: function() {


    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarEstoque.vue